'use strict';

define(['utils/underscore'], function (_) {

    var defaults = {
        //file: undefined,
        //label: undefined,
        kind: 'captions',
        'default': false
    };

    var Track = function Track(config) {
        // File is the only required attr
        if (!config || !config.file) {
            return;
        }

        return _.extend({}, defaults, config);
    };

    return Track;
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/playlist/track.js
 ** module id = 90
 ** module chunks = 0
 **/